import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";

import { Scrollbars } from "react-custom-scrollbars";

import { ADD_BET_IN_BETSLIP } from "./../../App/actions";

import BetsList from "./BetsList";
import { useGlobalDataContext } from "./../../../../GlobalDataContext";
import { stakeModes, lifecycleStates } from "./../../../utils/constants";
import { getFloor } from "./../../../utils/helpers";
import { toastreact } from "./../../../components/ToastMessage/index";
import { toastMessageTypes } from "./../../../components/ToastMessage/constants";
import ActionButton from "./../../../components/ActionButton";

import {
  checkIfCreditsValueIsLow,
  getNewBetsEventDelete,
  getNewBets,
  getSumDataFromBetsObject,
  getTipDataFromBetsObject,
  checkIfEmptyBetsObject,
} from "./../helpers";

import PreLoader from "./../../../components/PreLoader/PreLoader";

import { getActiveBetsObject } from "../../Bets/helpers";

import {
  getItemFromStorage,
  setItemInStorage,
} from "../../../utils/LocalStorageService";

const Betslip = () => {
  const { state, dispatch } = useGlobalDataContext();
  const { t } = useTranslation();

  const [autoHeightMaxScrollBar, setAutoHeightMaxScrollBar] = useState(500);
  const [stakeMode, setStakeMode] = useState(stakeModes.STAKE_PER_BET_MODE);
  const [disablePlaceBet, setDisablePlaceBet] = useState(false);
  const [maxWinning, setMaxWinning] = useState(0);
  const [totalStake, setTotalStake] = useState(0);
  const [betsCount, setBetsCount] = useState(null);
  const [isLowCredits, setIsLowCredits] = useState(false);
  const [stakeAmountIsToHeight, setStakeAmountIsToHeight] = useState(false);
  const [stakeAmountIsToLow, setStakeAmountIsToLow] = useState(false);
  const [placeBetsProcess, setPlaceBetsProcess] = useState(false);
  const [confirmBet, setConfirmBet] = useState(false);
  const [rememberConfirmBet, setRememberConfirmBet] = useState(false);

  const [maxWinnPerTicketDisable, setMaxWinnPerTicketDisable] = useState(false);

  const [maxWinPerTicket, setMaxWinPerTicket] = useState(0);

  const betsObjectByEvents = state.betsObject;
  const raceType = state.raceType;
  const ScrollbarsRef = useRef();

  // set min stake amount after fetched this data from the server
  React.useEffect(() => {
    if (Object.keys(state.appSettings).length <= 0) return;
    // setMaxWinPerTicket(state.appSettings.maxWinPerTicket);
  }, [state.appSettings]);

  // refresh info for betslip footer after stake amount changed or betsObject canged(add or remove bet)
  React.useEffect(() => {
    const basketEl = document.querySelector(".basket");
    if (basketEl) {
      setAutoHeightMaxScrollBar(basketEl.clientHeight - 200);
    }

    window.addEventListener("resize", () => {
      setAutoHeightMaxScrollBar(basketEl.clientHeight - 200);
      ScrollbarsRef.current.forceUpdate();
    });

    // check if there is no bet in betsObject and if true set all state variable to default
    if (checkIfEmptyBetsObject(state.betsObject)) {
      // setMaxWinnPerTicketDisable(false);
      setMaxWinning(0);
      setTotalStake(0);
      setBetsCount(0);
      setIsLowCredits(false);
      setStakeAmountIsToHeight(false);
      setStakeAmountIsToLow(false);
      return;
    }

    // set the correct bets object for split and stake per bet modes
    const betsObjectInReactUseEffect = { ...state.betsObject };

    const summaryData = getSumDataFromBetsObject(betsObjectInReactUseEffect);

    setTotalStake(summaryData.tempTotalStake);
    setMaxWinning(summaryData.tempMaxWinning);
    // if at least one ticket has winning amount bigger than max winning per ticket than disable place bets
    // setMaxWinnPerTicketDisable(
    //   summaryData.maxWinningPerTicket.filter(item => {
    //     return item > maxWinPerTicket || item > state.appSettings.maxWinPerBet;
    //   }).length > 0
    // );
    setBetsCount(summaryData.betsCount);
    // check if total stake amount bigger than user's credits
    const creditsValueIsLow = checkIfCreditsValueIsLow(
      summaryData.tempTotalStake,
      state.appSettings.credits
    );
    setIsLowCredits(creditsValueIsLow);

    // show notification msg if total stake amount for SPLIT_STAKE_MODE mode is bigger than max stake value
    // and if stake amount value is to low (less than min stake amount)
    setStakeAmountIsToHeight(
      summaryData.betsCount
        ? Number(summaryData.tempTotalStake) / summaryData.betsCount >
            state.lifecycleData.maxStake
        : false
    );

    setStakeAmountIsToLow(
      Number(summaryData.tempTotalStake) / summaryData.betsCount <
        state.lifecycleData.minStake
    );

    const toastifyContainerActiveLength = document.querySelectorAll(
      ".Toastify>.Toastify__toast-container"
    ).length;
    if (
      creditsValueIsLow &&
      summaryData.tempTotalStake > 0 &&
      toastifyContainerActiveLength === 0
    ) {
      toastreact({
        type: toastMessageTypes.ERROR,
        title: t("betslip.tooltip.stakeBiggerCreds"),
      });
    }
    if (
      (summaryData.betsCount
        ? Number(summaryData.tempTotalStake) / summaryData.betsCount >
          state.lifecycleData.maxStake
        : false) &&
      summaryData.tempTotalStake > 0 &&
      toastifyContainerActiveLength === 0
    ) {
      toastreact({
        type: toastMessageTypes.ERROR,
        title: t("betslip.tooltip.stakeBiggerMaxValue"),
      });
    }
    if (
      Number(summaryData.tempTotalStake) / summaryData.betsCount <
        state.lifecycleData.minStake &&
      summaryData.tempTotalStake > 0 &&
      toastifyContainerActiveLength === 0
    ) {
      // console.log(
      //   "summaryData.tempTotalStake) / betsCount",
      //   Number(summaryData.tempTotalStake) / summaryData.betsCount
      // );
      toastreact({
        type: toastMessageTypes.ERROR,
        title: t("betslip.tooltip.stakeLessMinValue"),
      });
    }

    // eslint-disable-next-line
  }, [state.betsObject]);

  // remove all bets of event with state RACE or BET_LOCKED
  React.useEffect(() => {
    if (state.currentLifecycleState === lifecycleStates.WINNING_PLAN) return;

    const activeBetsObject = getActiveBetsObject({
      betsObject: state.betsObject,
      eventsOdds: state.eventsOdds,
    });
    // show modal window with info about deleted bets by not available events
    if (activeBetsObject.expiredRaceIds.length > 0) {
      toggleModal("showInfoExpiredEvents");
    }

    // remove all bets for event with Race or Bet_locked state
    dispatch({
      type: ADD_BET_IN_BETSLIP,
      payload: activeBetsObject.betsObject,
    });
    // eslint-disable-next-line
  }, [state.eventsOdds]);

  // remove all bets by EVENT
  const onRemoveAllEventsBetsEventListener = (event) => {
    const eventId = event.currentTarget.getAttribute("data-event-id");
    toastreact({
      type: toastMessageTypes.WARN,
      title: t("betslip.tooltip.allBetsRemoved").replace("%eventId%", eventId),
    });
    dispatch({
      type: ADD_BET_IN_BETSLIP,
      payload: getNewBetsEventDelete(state.betsObject, eventId),
    });
  };

  // remove bets by one
  const onRemoveOneEventsBetsEventListener = (event) => {
    const betType = event.currentTarget.getAttribute("data-bet-type");
    const betTypeName = event.currentTarget.getAttribute("data-bet-type-name");
    const eventId = event.currentTarget.getAttribute("data-event-id");
    const betResult = event.currentTarget.getAttribute("data-bet-result");

    // Додаємо детальний лог для дебагінгу
    console.log("Attempting to remove bet:", {
      betType,
      betTypeName,
      eventId,
      betResult,
      betResultType: typeof betResult,
      betsObject: state.betsObject[eventId], // Логуємо ставки для цього eventId
    });

    toastreact({
      type: toastMessageTypes.WARN,
      title: `${betTypeName} ${t("betslip.tooltip.betOfEvent")} ${eventId} ${t(
        "betslip.tooltip.removeBetslip"
      )} `,
    });

    dispatch({
      type: ADD_BET_IN_BETSLIP,
      payload: getNewBets(state.betsObject, eventId, betType, betResult),
    });
  };

  // place bet event listener by Place Bet button
  const onPlaceBetEventListener = () => {
    let eventsId = Object.keys(state.betsObject).map((eventId) => {
      return eventId;
    });

    let betsObjectForRequests = {};
    for (const eventId of eventsId) {
      // if there are more than one event id than send bets for each event
      betsObjectForRequests[eventId] = getTipDataFromBetsObject(
        state.betsObject[eventId]
      );
      let betsObject = betsObjectForRequests[eventId];

      console.log(betsObject);

      if (window.chrome.webview) window.chrome.webview.postMessage(betsObject);
    }

    // clear betslip from bets
    dispatch({
      type: ADD_BET_IN_BETSLIP,
      payload: {},
    });
    setTimeout(() => {
      setConfirmBet(false);
    }, 300);
  };

  // close confirm bets block
  const onCancelPlaceBetEventListener = () => {
    setConfirmBet(false);
  };

  // remember choise in session storage and do not show confirm place bets component
  const onChangeShowConfirmPlaceBetsEvent = (e) => {
    setItemInStorage("showConfirmPlaceBets", e.currentTarget.checked, true);
    setRememberConfirmBet(!rememberConfirmBet);
  };
  // open modal
  const toggleModal = (modalName) => {
    dispatch({
      type: "OPEN_MODAL_WINDOW",
      payload: modalName,
    });
  };

  // change stake amount for one bet
  const onChangeStakeAmountBet = (event) => {
    const betType = event.currentTarget.getAttribute("data-bet-type");
    const eventId = event.currentTarget.getAttribute("data-event-id");

    // return new array of bet for one event id with changed stake amount
    function getNewArrayOfBetsWithChangedBetAmount() {
      return [...state.betsObject[eventId]].map((oneBet) => {
        const oneBetTip = Object.keys(oneBet)[0];
        const oneBetProps = oneBet[oneBetTip];
        let oneBetPropsC = { ...oneBetProps };
        if (oneBetTip === betType) {
          oneBetPropsC = { ...oneBetPropsC, stake: event.currentTarget.value };
        }
        return { [oneBetTip]: oneBetPropsC };
      });
    }

    dispatch({
      type: ADD_BET_IN_BETSLIP,
      payload: {
        ...state.betsObject,
        [eventId]: [...getNewArrayOfBetsWithChangedBetAmount()],
      },
    });
  };

  return (
    <>
      {placeBetsProcess && (
        <PreLoader
          isLoading={true}
          isLoadingText={t("betslip.tooltip.placingBets")}
          isLightPreLoader={false}
          showLoadingText={true}
          showInParent={true}
        />
      )}
      <div className="basket-tab-content">
        <Scrollbars
          className="basket-scrollbar"
          autoHeight={true}
          autoHeightMax={autoHeightMaxScrollBar}
          ref={ScrollbarsRef}
        >
          {Object.keys(betsObjectByEvents).length === 0 && (
            <div className="empty-bet-list align-center">
              {t("betslip.emptyMsg")}
            </div>
          )}
          {Object.keys(state.betsObject).map((eventId, index) => {
            const eventObj = betsObjectByEvents[eventId];

            return (
              eventObj.length > 0 && (
                <div key={index} className="event-bets-block">
                  <header className="event-bets-block-header">
                    <span
                      data-event-id={eventId}
                      onClick={onRemoveAllEventsBetsEventListener}
                      className="close-button-alt"
                    ></span>
                    <h2 className="top-title align-left">
                      {`${t("event")}  ${eventId}`}
                    </h2>
                    <div className="event-info">{t(raceType)}</div>
                  </header>
                  <main className="event-bets-block-main">
                    <BetsList
                      maxStake={state.lifecycleData.maxStake}
                      minStake={state.lifecycleData.minStake}
                      stakeMode={stakeMode}
                      eventObj={eventObj}
                      onRemoveOneEventsBetsEventListener={
                        onRemoveOneEventsBetsEventListener
                      }
                      onChangeStakeEventListener={onChangeStakeAmountBet}
                      eventId={eventId}
                      currency={" "}
                      isLowCredits={isLowCredits}
                      preNumbersUOText={state.lifecycleData.PreNumbersUOText}
                      firstNumberUOText={state.lifecycleData.FirstNumberUOText}
                    />
                  </main>
                </div>
              )
            );
          })}
        </Scrollbars>
        <footer className="stake-operation-block">
          <div className="stake-status">
            <div className="flex-row">
              <div
                className={cn("flex-col-11 font-bold mb-5", {
                  danger:
                    isLowCredits ||
                    stakeAmountIsToHeight ||
                    stakeAmountIsToLow ||
                    maxWinnPerTicketDisable,
                })}
              >
                {t("betslip.totalStake")}{" "}
              </div>
              <div
                className={cn(
                  "flex-col-10 align-right font-bold total-stake-amount",
                  {
                    danger:
                      isLowCredits ||
                      stakeAmountIsToHeight ||
                      stakeAmountIsToLow ||
                      maxWinnPerTicketDisable,
                  }
                )}
              >
                {`${getFloor(totalStake, 100)}`}
              </div>
            </div>
            {/*<div className="flex-row">*/}
            {/*  <div*/}
            {/*    className={cn(`flex-col-11 font-light mb-5`, {*/}
            {/*      danger: maxWinnPerTicketDisable*/}
            {/*    })}*/}
            {/*  >*/}
            {/*    {t("betslip.maxWinning")}*/}
            {/*  </div>*/}
            {/*  <div*/}
            {/*    className={cn(*/}
            {/*      "flex-col-10 align-right font-light max-wining-state",*/}
            {/*      {*/}
            {/*        danger: maxWinnPerTicketDisable*/}
            {/*      }*/}
            {/*    )}*/}
            {/*  >*/}
            {/*    {`${getFloor(maxWinning, 100)}`}*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className="flex-row">
              <div className="flex-col-11 font-light mb-5 small-text">
                {t("betslip.minStake")}
              </div>
              <div className="flex-col-10 align-right font-light max-wining-state small-text">
                {`${state.lifecycleData.minStake}`}
              </div>
            </div>

            <div className="flex-row hide-for-mobile">
              <div className="flex-col-11 font-light small-text">
                {t("betslip.maxStake")}
              </div>
              <div className="flex-col-10 align-right font-light max-wining-state small-text">
                {`${state.lifecycleData.maxStake}`}
              </div>
            </div>
          </div>

          <div
            data-tip={
              betsCount === 0
                ? t("betslip.tooltip.selectBet")
                : isLowCredits
                ? t("betslip.tooltip.stakeBiggerCreds")
                : stakeAmountIsToHeight
                ? t("betslip.tooltip.stakeBiggerMaxValue")
                : stakeAmountIsToLow
                ? t("betslip.tooltip.stakeLessMinValue")
                : maxWinnPerTicketDisable
                ? t("betslip.tooltip.winExceedMaxWin")
                : ""
            }
            className={cn({
              disable: betsCount === 0 || betsCount === null || disablePlaceBet,
            })}
          >
            {(betsCount === 0 || betsCount === null || disablePlaceBet) && (
              <div className={"disable-block"}></div>
            )}
          </div>
          {/* place bet button */}
          <ActionButton
            tooltip={
              betsCount === 0
                ? t("betslip.tooltip.selectBet")
                : isLowCredits
                ? t("betslip.tooltip.stakeBiggerCreds")
                : stakeAmountIsToHeight
                ? t("betslip.tooltip.stakeBiggerMaxValue")
                : stakeAmountIsToLow
                ? t("betslip.tooltip.stakeLessMinValue")
                : maxWinnPerTicketDisable
                ? t("betslip.tooltip.winExceedMaxWin")
                : ""
            }
            // there is no need to show confirmation popup for bet placing
            // onclick={
            //   getItemFromStorage("showConfirmPlaceBets", true) === false ||
            //   getItemFromStorage("showConfirmPlaceBets", true) === undefined
            //     ? () => {
            //         if (
            //           state.currentLifecycleState === lifecycleStates.BET_LOCKED
            //         )
            //           return;
            //         setConfirmBet(true);
            //       }
            //     : onPlaceBetEventListener
            // }
            onclick={onPlaceBetEventListener}
            classesName={cn("place-bet-button", {
              inactive:
                betsCount === 0 ||
                isLowCredits ||
                stakeAmountIsToHeight ||
                stakeAmountIsToLow ||
                disablePlaceBet ||
                maxWinnPerTicketDisable ||
                state.currentLifecycleState === lifecycleStates.BET_LOCKED,
            })}
            buttonBlinkDisable={
              betsCount === 0 ||
              isLowCredits ||
              stakeAmountIsToHeight ||
              maxWinnPerTicketDisable
            }
          >
            {state.currentLifecycleState === lifecycleStates.BET_LOCKED
              ? t("betslip.betLocked")
              : t("betslip.placeBet")}

            {state.currentLifecycleState ===
            lifecycleStates.BET_LOCKED ? null : (
              <span>({`${getFloor(totalStake, 100)}`})</span>
            )}
          </ActionButton>
        </footer>
      </div>
    </>
  );
};

export default Betslip;